<div class="client-management-dialog-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ 'BUTTON.EDIT' | translate }} {{ 'CLIENT.SUBSCRIPTION_TYPES.' + data.subscription.type | translate }}</span>
		<button mat-icon-button (click)="cancel()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-3">
		<form [formGroup]="editForm">
			<div class="row pt-2">
				<!-- Email To Section -->
				<div class="row">
					<mat-form-field class="w-100 pb-3">
						<mat-label>{{ 'CLIENT.EMAIL_TO' | translate }}</mat-label>
						<mat-chip-grid #emailToGrid aria-label="E-mail selection">
							@for (email of selectedEmailsTo; track $index) {
							<mat-chip-row (removed)="manageEmails('emailTo', 'REMOVE', email)">
								{{ email }}
								<button matChipRemove [attr.aria-label]="'remove ' + email">
									<mat-icon>cancel</mat-icon>
								</button>
							</mat-chip-row>
							}
						</mat-chip-grid>
						<input
							#emailToInput
							formControlName="emailTo"
							[matChipInputFor]="emailToGrid"
							[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
							(matChipInputTokenEnd)="manageEmails('emailTo', 'ADD', $event)" />
					</mat-form-field>
				</div>

				<!-- Email Cc Section -->
				<div class="row">
					<mat-form-field class="w-100 pb-3">
						<mat-label>{{ 'CLIENT.EMAIL_CC' | translate }}</mat-label>
						<mat-chip-grid #emailCcGrid aria-label="E-mail CC selection">
							@for (email of selectedEmailsCc; track $index) {
							<mat-chip-row (removed)="manageEmails('emailCc', 'REMOVE', email)">
								{{ email }}
								<button matChipRemove [attr.aria-label]="'remove ' + email">
									<mat-icon>cancel</mat-icon>
								</button>
							</mat-chip-row>
							}
						</mat-chip-grid>
						<input
							#emailCcInput
							formControlName="emailCc"
							[matChipInputFor]="emailCcGrid"
							[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
							(matChipInputTokenEnd)="manageEmails('emailCc', 'ADD', $event)" />
					</mat-form-field>
				</div>
			</div>


			<!-- TAGS selection -->
			@if(showTagsSection) {
			<div class="row">
				<mat-accordion #tagsAccordion="matAccordion" multi>
					@for (category of tagCategories; track $index ) {
					<mat-expansion-panel (opened)="accordionAction('open', category)" (closed)="accordionAction('close', category)" [expanded]="category.isOpened">
						<mat-expansion-panel-header>
							<mat-panel-title>
								<span>
									{{ utils.getParameterByName(category, 'value') }}
								</span>
							</mat-panel-title>
							<mat-panel-description> </mat-panel-description>
						</mat-expansion-panel-header>

						<div class="d-flex flex-row flex-wrap p-2">
							<span class="list-section w-100">
								<ul class="p-0 m-0">
									<ng-container formArrayName="clientTagsDetails">
										@for (tag of utils.getParameterByName(category, 'tags'); track tag.id) {
										<li class="d-flex align-items-start justify-content-between" [formGroupName]="tag.index">
											<mat-checkbox (change)="manageClientTag(tag.index, 'checked', $event)" formControlName="checked">
												<div class="d-flex">
													<div class="tag-item" [style.background-color]="tag.colorCode"></div>
													<span>{{ tag.value }}</span>
												</div>
											</mat-checkbox>

										</li>
										}
									</ng-container>
								</ul>
							</span>
						</div>
					</mat-expansion-panel>
					}
				</mat-accordion>
			</div>
			}
			<!-- (END)TAGS selection -->
		</form>
	</mat-dialog-content>

	<mat-dialog-actions [align]="'end'" class="pe-4">
		<mat-divider class="w-100 my-2"></mat-divider>
		<div class="gap-2 d-flex justify-content-end pt-0">
			<button mat-flat-button type="submit" color="primary" [disabled]="!checkFormValidity()" (click)="save()">
				{{ 'BUTTON.CONFIRM' | translate }}
			</button>
			<button mat-flat-button type="button" color="primary" (click)="cancel()">
				{{ 'BUTTON.CANCEL' | translate }}
			</button>
		</div>
	</mat-dialog-actions>
</div>